import { Injectable } from '@angular/core';
import {Resolve, ActivatedRouteSnapshot} from '@angular/router';

import {Observable} from 'rxjs/Observable';
import 'rxjs/add/operator/map';

import {LocaleService} from './locale.service';

@Injectable()
export class LocaleResolveService implements Resolve<any> {

    constructor(private localeService: LocaleService) {
    }

    resolve(route: ActivatedRouteSnapshot): Observable<any> {
        return this.localeService.getLocaleByIp();
    }
}



// WEBPACK FOOTER //
// ./src/app/core/services/locale-resolve.service.ts